import {getNewOutlet, getOutlet} from 'reconnect.js';
import * as JStorage from '../JStorage';
import * as ApiUtil from './ApiUtil';
import Config from '../../data.json';

export async function onCtxRendered() {
  let configs = null;

  if (Config.siteCacheUrl) {
    try {
      let siteCache = await ApiUtil.req(Config.siteCacheUrl, {
        headers: {
          'Cache-Control': 'no-cache',
        },
      });

      configs = siteCache.map((config) => {
        let nextConfig = {...config, id: config._id.$oid};
        return nextConfig;
      });
    } catch (ex1) {
      console.warn('[AppContext] siteCacheUrl is set but no data');
    }
  }

  if (!configs) {
    try {
      configs = await JStorage.fetchDocuments('site', {}, null, null, null, {
        anonymous: true,
      });
    } catch (ex2) {
      console.warn('[AppContext] fail to fetch site collection');
      configs = [];
    }
  }

  getOutlet('site').update(configs || []);

  for (const cfg of configs) {
    if (cfg.name === 'sales_event_category') {
      cfg.categories.meta_data = {
        ...cfg.meta_data,
      };

      getOutlet('salesEventCategories').update(cfg.categories || []);
    } else if (cfg.name === 'landing') {
      getOutlet('landing').update(cfg || []);
    } else if (cfg.name === 'config') {
      getOutlet('config').update(cfg || []);
    } else if (cfg.name === 'about') {
      getOutlet('about').update(cfg || []);
    } else if (cfg.name === 'navbar_config') {
      getOutlet('navbarConfig').update(cfg);
    } else if (cfg.name === 'footer_config') {
      getOutlet('footerConfig').update(cfg);
    } else if (cfg.name === 'customer_support_config') {
      getOutlet('customer_support_config').update(cfg);
    }
  }
}
